/**
 * 诉求显示名（标签体系 v2 批 1：显示名合一）。只读后端元信息 `demand_labels`——它由意图表 name 一处派生，
 * 含表外历史键 ／ 评测归一类的兜底中文名；页面不再各写一份（原 plan-labels `DEMAND_TYPE_ZH`、执行抽屉 `INTENT_ZH` 已删）。
 * 元信息没拿到时原样显示键（加载中一闪），不另留副本兜底。
 */
import { useCallback } from "react";

import { usePlanMeta } from "@/lib/api/plan-lab";

export type DemandLabel = (k?: string | null) => string;

export function useDemandLabel(): DemandLabel {
	const labels = usePlanMeta().data?.demand_labels;
	return useCallback((k?: string | null) => (k ? (labels?.[k] ?? k) : "—"), [labels]);
}
